import { createContext } from 'react';

export const StepContext = createContext<{
  orientation: 'vertical' | 'horizontal';
  stepCount: number;
  currentStep: number;
  stepIndex: number;
  onChange?: () => void;
}>({
  orientation: 'horizontal',
  stepCount: 0,
  currentStep: 0,
  stepIndex: 0,
});
